import { render } from "./GradientButton.vue?vue&type=template&id=00fe970a&scoped=true"
import script from "./GradientButton.vue?vue&type=script&lang=js"
export * from "./GradientButton.vue?vue&type=script&lang=js"

import "./GradientButton.vue?vue&type=style&index=0&id=00fe970a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00fe970a"]])

export default __exports__